// extracted by mini-css-extract-plugin
module.exports = {"ErpAgentsPanel":"ERPAgentsPanel_ErpAgentsPanel__1xTUM","erpAgentsPanelContainer":"ERPAgentsPanel_erpAgentsPanelContainer__3mnv5","loading":"ERPAgentsPanel_loading__2zJYc"};